<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.userName"
              placeholder="请输入名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.status"
              placeholder="状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.data"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @remove="removeFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
        @batchImport="batchImportFun"
      />
    </div>

    <!-- 新增 修改 查看-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditViewTitle"
      :dialog-visible.sync="dialogAddEditViewVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
    <!-- 批量导入数据 组件 -->
    <import-dialog
      :dialog-visible.sync="dialogImportVisible"
      :dialog-title="dialogImportTitle"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// 批量导入数据 组件
import importDialog from './components/importDialog';
// 保单API
import { loadUserInsurancePolicyListDataApi, exportUserInsurancePolicyListDataApi, deleteUserInsurancePolicyApi } from '@/api/v2/userInsurancePolicy';

export default {
  name: 'UserInsurancePolicy',
  components: {
    CustomTable2,
    TableOperation2,
    addEditViewDialog,
    importDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'user_insurance_policy_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['user_insurance_policy_add'],
            prop: 'batchImport',
            label: '批量导入',
            method: 'batchImport'
          },
          {
            permissionSigns: ['user_insurance_policy_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['user_insurance_policy_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['user_insurance_policy_del'],
            prop: 'remove',
            label: '作废',
            method: 'remove'
          },
          {
            permissionSigns: ['user_insurance_policy_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['user_insurance_policy_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          userName: '',
          status: ''
        }
      },
      // 选中的数据ID
      id: null,
      eventType: '',
      dialogAddEditViewTitle: '',
      dialogAddEditViewVisible: false,
      statusOptions: [{ label: '在保', data: 1 }, { label: '停保', data: 2 }],
      // 批量导入
      dialogImportVisible: false,
      dialogImportTitle: '导入保单数据'
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'typeValue', filterColumn: 'type', filterValue: 'type', label: '人员类型', width: 110, filterArray: [{ label: '临时促销人员', value: 1 }, { label: '礼仪', value: 2 }, { label: '主持', value: 3 }] },
      { prop: 'userName', label: '人员名称', filterColumn: 'user_name', width: 120 },
      { prop: 'policyNo', label: '保单号', filterColumn: 'policy_no', width: 180 },
      { prop: 'splitNo', label: '分单号', filterColumn: 'split_no', width: 180 },
      { prop: 'userNo', label: '保单客户号码', filterColumn: 'user_no', width: 180 },
      { prop: 'startDate', filterColumn: 'start_date', label: '有效开始日期', width: 140, isBetween: true },
      { prop: 'endDate', filterColumn: 'end_date', label: '退保日期', width: 140, isBetween: true },
      { prop: 'statusValue', filterColumn: 'status', filterValue: 'status', label: '状态', width: 80, filterArray: [{ label: '在保', value: 1 }, { label: '停保', value: 2 }] },
      { prop: 'remark', label: '备注' },
      { prop: 'creatorName', filterColumn: 'creator_name', label: '创建人', width: 100 },
      { prop: 'createTime', filterColumn: 'create_time', label: '创建时间', width: 150, isBetween: true },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 100 },
      { prop: 'operationTime', filterColumn: 'operation_time', label: '操作时间', width: 150, isBetween: true },
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadUserInsurancePolicyListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        this.handleData(data.list || [])
        this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 新增
    addFun () {
      let _this = this;
      _this.eventType = 'add'
      _this.dialogAddEditViewTitle = '新增人员保单信息'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
    },
    // 修改
    editFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditViewTitle = '修改人员保单信息'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditViewTitle = '查看人员保单信息'
      _this.dialogAddEditViewVisible = !_this.dialogAddEditViewVisible
    },
    // 作废
    removeFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择数据行', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该保单？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteUserInsurancePolicyApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 批量导入
    batchImportFun () {
      let _this = this;
      _this.dialogImportVisible = !_this.dialogImportVisible;
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportUserInsurancePolicyListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
